<template>
  <div>
    <b-table
      :ref="tableId"
      outlined
      responsive
      head-variant="primary"
      striped
      hover
      tbody-class="font-sm"
      :fields="fields"
      :items="dataProvider"
      :per-page="perPage"
      :current-page="currentPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      no-local-sorting
      sort-icon-right
      show-empty
      :empty-text="effectiveNoResultsText"
    >
      <!-- Pass through all slots so Parent can customized dom in table -->
      <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">
        <slot :name="scopedSlotName" v-bind="slotData" />
      </template>
      <!-- Default for every other field -->
      <template v-slot:cell()="data">
        <div>{{ data.value }}</div>
      </template>
    </b-table>
    <b-row class="flex-row-reverse justify-content-between">
      <b-col sm="6" md="5">
        <b-pagination
          class="mt-2 mt-lg-auto"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
        />
      </b-col>
      <b-col sm="6" md="6">
        <b-row>
          <b-col cols="auto" lg="5">
            <span class="font-sm">{{ totalRows }} {{ countLabel }}</span>
          </b-col>
          <b-col>
            <b-form-group
              :label="`${perPageLabel} per page`"
              label-cols="5"
              label-cols-sm="7"
              label-align="right"
              label-size="sm"
              :label-for="perPageSelectId"
            >
              <div class="d-flex h-100 d-lg-inline-block align-items-center">
                <b-form-select
                  :id="perPageSelectId"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                />
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'PaginatedTable',
  props: {
    tableId: {
      type: String,
      required: true,
    },
    fields: {
      type: Array,
      default: null,
    },
    initialSortBy: {
      type: String,
    },
    initialSortDesc: {
      type: Boolean,
      default: false,
    },
    noResultsText: {
      type: String,
      default: 'No Results.',
    },
    searchFilters: {
      type: Array,
    },
    countLabel: {
      type: String,
      default: 'Notifications',
    },
    perPageLabel: {
      type: String,
      default: 'FONS',
    },
    pageOptions: {
      type: Array,
      default: () => [5, 10, 15],
    },
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      sortBy: this.initialSortBy || this.fields[0].key,
      sortDesc: this.initialSortDesc,
      currentPage: 1,
      totalRows: 0,
      perPage: this.pageOptions[0],
      hasError: false,
    };
  },
  computed: {
    perPageSelectId() {
      return `${this.tableId}-per-page-select`;
    },
    effectiveNoResultsText() {
      if (this.hasError) {
        return 'Error loading data. Please refresh the page. If the problem persists, please contact your system administrator.';
      }
      return this.noResultsText;
    },
  },
  watch: {
    searchFilters() {
      this.$refs[this.tableId].refresh();
    },
  },
  methods: {
    dataProvider(ctx, callback) {
      let query = `?page=${ctx.currentPage}&pageSize=${ctx.perPage}&sortBy=${ctx.sortBy}&sortDesc=${ctx.sortDesc}`;
      if (this.searchFilters) {
        query += this.searchFilters.map(term => `&${term.key}=${term.value}`).join('');
      }
      this.hasError = false;
      this.$http.get(`${this.url}${query}`).then((response) => {
        this.totalRows = response.data.count;
        callback(response.data.data);
      }).catch((e) => {
        // this usually a result of the session timing out
        console.warn('Fetch error:', e);
        this.hasError = true;
        this.totalRows = 0;
        callback([]);
      });
    },
  },
};
</script>
